import { ThunkAction } from "../types";

import { createPush as createPushAction } from "../actions";
import { IPushRequest } from "../api/APIClient";

export function createPush(push: IPushRequest): ThunkAction {
  return async (dispatch, _, { api }) => {
    try {
      dispatch(createPushAction.request());

      await api.createPush(push);

      dispatch(createPushAction.success());
    } catch (err) {
      dispatch(createPushAction.failure(err));
    }
  };
}



// WEBPACK FOOTER //
// ./src/thunks/pushThunks.ts